import React, { Suspense, useEffect, useState } from "react";
import {  Box, Button, CircularProgress, Divider, Typography,  useTheme  } from "@mui/material";
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import TopBar from "../../components/agent/TopBar";
import apiInstance from "../../services/ServiceApi";
import BuscarCliente from "../../components/agent/cliente/BuscarCliente";
import AlertModal from "../../components/utilities/AlertModal";
 
const Cliente = React.lazy(() => import('../../components/agent/cliente/Cliente'));
const HistoricoGestiones = React.lazy(() => import('../../components/agent/historico/HistoricoGestiones'));
const Cuentas = React.lazy(() => import('../../components/agent/cuenta/CuentasVentas'));
const MemoizedCuentas = React.memo(Cuentas);

const GestionVenta = () => {
  const theme = useTheme();
  const location = useLocation();
  const [modalSearchOpen, setModalSearchOpen] = useState(false);
  const [campaignDiscadorExists, setCampaignDiscadorExists] = useState(false);
  const [lineaNegocio, setLineaNegocio] = useState(null);
  const [formulario, setFormulario] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const handleCloseModalAlert = () => {    setModalOpen(false); };
  const parsed = queryString.parse(location.search);
  const uniqueid = parsed.uniqueid || parsed.callid || -1;
  const campaign = parsed.campaign;
  const user = parsed.user;
  const phone_number = parsed.phone_number;
  const [idCliente, setIdCliente] = useState(null);
  const [vendorId, setVendorId] = useState(parsed.vendor_id);

  const manejarIdCliente = (idCliente) => {
    setIdCliente(idCliente);
  };
  const handleSelectClient = (id) => {
    setVendorId(id);
    setModalSearchOpen(false);
  }

  useEffect(() => {
      if (campaign) {
        apiInstance.get('/campania/', {params:{ campania: campaign} })
          .then(response => {
              setCampaignDiscadorExists(true);  
              console.log(response.data);
              setLineaNegocio(response.data.linea_negocio);
              setFormulario(response.data.formulario);
              setModalOpen(false)
          
          })
          .catch(error => {
            setCampaignDiscadorExists(false);
            setModalOpen(true)
          });
      }
    }, [campaign]);
    return (
      <Box sx={{ flexGrow: 1, padding: 2, mx: [1, 2, 3], bgcolor: theme.palette.background.default }}>
        <TopBar asesor={vendorId} codLlamada={uniqueid} numeroMarcado={phone_number} />
        <Button variant="contained" color="success" onClick={() => setModalSearchOpen(true)}>Buscar Cliente</Button>
  
        <BuscarCliente
          open={modalSearchOpen}
          onClose={() => setModalSearchOpen(false)}
          idLineaNegocio={lineaNegocio.id}
          idCartera={1}
          onSelectClient={handleSelectClient}
        />
        {campaignDiscadorExists ? (
          <>
            <Suspense fallback={<CircularProgress />}>
              <Cliente identificador={vendorId} lineaNegocio={lineaNegocio} manejarIdCliente={manejarIdCliente}  campania={campaign}/>
            </Suspense>
            {idCliente && lineaNegocio && (


            <>
            <Suspense fallback={<CircularProgress />}>
    <MemoizedCuentas
      identificador={vendorId}
      id_linea_negocio={lineaNegocio.id}
      id_cartera={1}
      codigo_llamada={uniqueid}
      codigo_usuario={user}
      numero_contactado={phone_number}
      campaign={campaign}
      idCliente={idCliente}
      formulario={formulario}
    />
</Suspense>

<Box my={1}>  {/* Este Box agregará márgenes arriba y abajo */}
    <Divider sx={{ padding: '2' }} />
</Box>

<Suspense fallback={<CircularProgress />}>
    <Box mb={2}>
        <HistoricoGestiones id_cliente={idCliente} codigo_usuario={user} />
    </Box>
</Suspense>
            
            
            </>
            )}
          </>
        ) : (
          <Typography variant="h6">
            <AlertModal
              open={modalOpen}
              onClose={handleCloseModalAlert}
              alertType={'error'}
              message={`No se encontró la campaña ${campaign}`}
            />

          </Typography>
        )}
      </Box>
    );
  };
  
  export default GestionVenta;